/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaCodiceAnprDTO } from '../model/models';
import { PraticaCodiceAnprUpdateForm } from '../model/models';
import { PraticaConflittoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetPraticaConflittiRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface PatchPraticaCodiceAnprRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaCodiceAnprUpdateForm: PraticaCodiceAnprUpdateForm;
}


export interface GestionePraticheCodiceANPREConflittiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Pratiche dello stesso bando in conflitto con questa: codice fiscale in comune (richiedente o nucleo, se il bando ammette una sola domanda per cittadino) o stesso codice ANPR (se il bando lo abilita). Esclusa la pratica stessa e IN_ATTESA_OTP. Response: lista di {id_pratica, codice_pratica, stato, timestamp_richiesta, motivi[CF|ANPR]}, senza dati personali dell\&#39;altra pratica.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/conflitti
* @param requestParameters
     */
    getPraticaConflitti(requestParameters: GetPraticaConflittiRequestParams, extraHttpRequestParams?: any): Observable<Array<PraticaConflittoDTO>>;

    /**
     * Imposta/modifica/cancella il codice ANPR della pratica (solo operatore). Body: {codice_anpr, version}; il valore e\&#39; normalizzato dal server (maiuscolo, senza spazi; vuoto/null &#x3D; cancella). Modificabile solo in RICHIESTA_SOTTOMESSA e RICHIESTA_IN_LAVORAZIONE. Response 200: {codice_anpr, version, conflitti[]}. 404 pratica/cross-bando, 409 optimistic lock o soft lock, 422 pratica_codice_anpr_non_abilitato | pratica_codice_anpr_non_modificabile_in_stato | pratica_codice_anpr_non_valido.
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/codice-anpr
* @param requestParameters
     */
    patchPraticaCodiceAnpr(requestParameters: PatchPraticaCodiceAnprRequestParams, extraHttpRequestParams?: any): Observable<PraticaCodiceAnprDTO>;

}
